import { CircularProgress, Typography, Box, Stack, LinearProgress} from '@mui/material';
import * as Yup from 'yup';
import { FormikConfig } from 'formik';
import React from 'react';
import FilterComponentV2 from '../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import { requiredField } from '../../lib/helperFuncs';
import Theme from '../../Themes/main.theme';
import { FieldControllerTypes } from '../../components/form_v2/types';
import HttpService from '../../services/HttpService';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const Zoom = () => {
  const [data, setData] = React.useState<any[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const onSubmit = async (values: FormikConfig<any>) => {
    setIsLoading(true);
    try {
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/zoom/meetings`, {
        params: values
      });
      setError('');
      setData(response.data.participants);
    } catch (error: any) {
      console.error(error);      
      setError(error.response.data.message);
    }
    setIsLoading(false);
  };

  const validationSchema = Yup.object({
    meetingId:
      Yup.string()
        .required(requiredField)});

  const filterFields = [
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'meetingId',
      label: 'Zoom Meeting / Webinar ID',
      filtersDesign: true,
      required: true,
      customLabel: true
    }
  ];
  const initialValue = { meetingId: ''};

  const columns: GridColDef[] = [
    {
      field: "user_email",
      headerName: "E-mail",
      minWidth: 300,
    },
    {
      field: "name",
      headerName: "Ονοματεπώνυμο",
      minWidth: 300,
    },
    {
      field: "duration",
      headerName: "Διάρκεια Συμμετοχής (Σε λεπτά)",
      minWidth: 300,
    },
  ];

  return (
    <>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}>Zoom Meetings / Webinars</Typography>
      <FilterComponentV2
        title='Αναζήτηση Χρηστών'
        validationSchema={validationSchema}
        filterFields={filterFields}
        initialValues={initialValue}
        resetFilters={true}
        changeFilters={filterValues => onSubmit(filterValues)}
        validateOnBlur={false}
      />
      <Box mt={5} sx={{ display: 'flex', justifyContent: 'center'}}>
        {isLoading
          ? <CircularProgress />
          : error
            ? <Typography variant='h4'>
              {error}
            </Typography> 
            : data.length === 0 
              ? <></>
              : <DataGrid
                disableColumnMenu
                disableSelectionOnClick
                autoHeight
                sortingMode='server'
                columns={columns}
                rows={data}
                components={{
                  LoadingOverlay: LinearProgress,
                  NoRowsOverlay: () => (
                    <Stack
                      height='100%'
                      alignItems='center'
                      justifyContent='center'
                    >
                      Δεν υπάρχουν εγγραφές
                    </Stack>
                  ),
                }}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#F2F2F2",
                    fontSize: 16,
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    textOverflow: "clip",
                    whiteSpace: "break-spaces",
                    lineHeight: 1,
                  },
                  "& .MuiDataGrid-cell": {
                    textOverflow: "clip",
                    whiteSpace: "break-spaces",
                    lineHeight: 1,
                  },
                }}
              />
        }
      </Box>
    </>
  );
};

export default Zoom;